import PortFlagAndName from './PortFlagAndName'

export default PortFlagAndName
